/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { TableSection } from "./TableSection";
import styles from "./Table.module.css";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import SwapVertIcon from "@mui/icons-material/SwapVert";

export const FeatureTable = ({ featureList, deleteFeature }) => {
  const handleDeleteFeature = (props) => {
    deleteFeature(props);
  };
  const [currentApps, setCurrentApps] = useState([]);
  const [sorting, setSorting] = useState({
    key: "lastModified",
    ascending: false,
  });

  function applySorting(key, ascending) {
    setSorting({ key: key, ascending: ascending });
  }

  useEffect(() => {
    if (featureList.length > 0) {
      const sortedCurrentApps = [...featureList].toSorted((a, b) => {
        return a[sorting.key].localeCompare(b[sorting.key]);
      });

      setCurrentApps(
        sorting.ascending ? sortedCurrentApps : sortedCurrentApps.toReversed()
      );
    }
  }, [sorting, featureList]);

  return (
    <table>
      <thead className={styles.tableHeaderCls}>
        <tr>
          <th></th>
          <th
            onClick={() => applySorting("applicationName", !sorting.ascending)}
          >
            Feature Name
            {sorting.key === "applicationName" && (
              <span>
                {!sorting.ascending && (
                  <ArrowUpwardIcon className={styles.arrowSortCls} />
                )}
                {sorting.ascending && (
                  <ArrowDownwardIcon className={styles.arrowSortCls} />
                )}
              </span>
            )}
            {sorting.key !== "applicationName" && (
              <SwapVertIcon className={styles.arrowSortCls1} />
            )}
          </th>
          <th>Category</th>
          <th>Version</th>
          <th>Status</th>
          <th onClick={() => applySorting("lastModified", !sorting.ascending)}>
            Last Modified
            {sorting.key === "lastModified" && (
              <span>
                {sorting.ascending && (
                  <ArrowDownwardIcon className={styles.arrowSortCls1} />
                )}
                {!sorting.ascending && (
                  <ArrowUpwardIcon className={styles.arrowSortCls1} />
                )}
              </span>
            )}
            {sorting.key !== "lastModified" && (
              <SwapVertIcon className={styles.arrowSortCls1} />
            )}
          </th>
          <th>No. of Installs</th>
          <th></th>
        </tr>
      </thead>

      {featureList.length === 0 && sorting && (
        <tbody>
          <tr>
            <td colSpan={5} style={{ textAlign: "center" }}>
              No Data found
            </td>
          </tr>
        </tbody>
      )}
      {featureList.length > 0 && !sorting && (
        <tbody>
          {featureList.map((feature, index) => (
            <TableSection
              key={feature.id || index}
              item={feature}
              index={index}
              deleteItem={handleDeleteFeature}
              type="feature"
            ></TableSection>
          ))}
        </tbody>
      )}

      {featureList.length > 0 && currentApps.length > 0 && sorting && (
        <tbody>
          {currentApps.map((feature, index) => (
            <TableSection
              key={feature.id || index}
              item={feature}
              index={index}
              deleteItem={handleDeleteFeature}
              type="feature"
            ></TableSection>
          ))}
        </tbody>
      )}
    </table>
  );
};

FeatureTable.propTypes = {
  featureList: PropTypes.array.isRequired,
  deleteFeature: PropTypes.func.isRequired,
};
